import { Controller } from "@hotwired/stimulus"

// A clean file picker for the sample-upload page: a styled drop zone stands in
// for the native "Choose file / No file chosen" control. Clicking the zone (or
// dropping a file on it) feeds the sr-only <input type=file> and swaps the hint
// for the chosen file's name. Mirrors the uploads new-page drop zone, trimmed
// to a single file with no customer/template wiring.
export default class extends Controller {
  static targets = ["input", "hint", "chosen", "name"]

  open() {
    this.inputTarget.click()
  }

  dragover(event) {
    event.preventDefault()
    this.element.classList.add("border-orange-400")
  }

  dragleave() {
    this.element.classList.remove("border-orange-400")
  }

  drop(event) {
    event.preventDefault()
    this.element.classList.remove("border-orange-400")
    if (event.dataTransfer.files.length) {
      this.inputTarget.files = event.dataTransfer.files
      this.changed()
    }
  }

  changed() {
    const file = this.inputTarget.files[0]
    if (!file) return
    this.nameTarget.textContent = file.name
    this.hintTarget.hidden = true
    this.chosenTarget.hidden = false
  }
}
